import type {Conversation} from '@/client/mentor/ConversationsClient'
import type {Maybe} from '@/types'
import {defineStore} from 'pinia'
import {computed, readonly, ref} from 'vue'

export const useAssistantStore = defineStore('assistant', () => {
  // Helper to create togglable boolean state
  const createTogglableBoolean = (initialValue: boolean) => {
    const state = ref(initialValue)
    return {
      state,
      toggle: () => {
        state.value = !state.value
      },
    }
  }

  const activeConversation = ref<Conversation>()
  const activeConversationId = computed(() => activeConversation.value?.id)
  const unreadConversationIds = ref(new Set<string>())

  const visible = createTogglableBoolean(false)

  const hasUnreadConversations = computed(() => unreadConversationIds.value.size > 0)

  function setActiveConversation(conversation: Maybe<Conversation>) {
    activeConversation.value = conversation ?? undefined
    if (conversation) {
      unreadConversationIds.value.delete(conversation.id)
    }
  }

  return {
    activeConversation: readonly(activeConversation),
    activeConversationId,
    setActiveConversation,
    unreadConversationIds,
    hasUnreadConversations,
    isVisible: readonly(visible.state),
    toggleVisible: visible.toggle,
  }
})
